module.exports = __webpack_public_path__ + "img/slide1.ce58f411.png";